import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import selectors from 'selectors'
import jobTemplateActions from 'actions/jobTemplates'
import operatorActions from 'actions/operators'
import locationGroupActions from 'actions/locationGroups'
import locationActions from 'actions/locations'
import assetCategoryActions from 'actions/assetCategories'
import assetActions from 'actions/assets'
import Component from 'components/JobSchedule/Filter'

const mapStateToProps = (state, props) => ({
  ...createAuthStateToProps(state, props),
  jobTemplates: selectors.jobTemplates.selectOptions(state),
  operators: selectors.operators.selectOptions(state, { itemsOnly: false }),
  locationGroups: selectors.locationGroups.selectOptions(state),
  locations: selectors.locations.selectOptions(state),
  assetCategories: selectors.assetCategories.selectOptions(state),
  assets: selectors.assets.selectOptions(state, { itemsOnly: false }),
})

const mapDispatchToProps = (dispatch, props) => ({
  getJobTemplates: (params) => dispatch(jobTemplateActions.getOptions(params)),
  getOperators: (params) =>
    dispatch(
      operatorActions.getOptions({
        active: 'All',
        pageIndex: 1,
        pageSize: 100,
        ...params,
      }),
    ),
  getLocationGroups: (params) => dispatch(locationGroupActions.getOptions(params)),
  getLocations: (params) =>
    dispatch(locationActions.getOptions({ ...params, active: 'All', locationVendingTypes: ['NonVending'] })),
  getAssetCategories: (params) => dispatch(assetCategoryActions.getOptions(params)),
  getAssets: (params) =>
    dispatch(
      assetActions.getOptions({
        pageIndex: 1,
        pageSize: 100,
        ...params,
      }),
    ),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
